// IframeOnboard.jsx
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import styles from './onboard.module.css';

// PRELOAD MANUAL
const preloadHome = () => import('../../../app/pages/homePage/home'); // Ruta real a tu componente Home

const IframeOnboard = () => {
  const navigate = useNavigate();
  const [showIframe, setShowIframe] = useState(true);

  useEffect(() => {
    // Preload al iniciar
    preloadHome();

    const handleMessage = (event) => {
      if (event.data === 'onboardFinished') {
        setShowIframe(false);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleExitComplete = () => {
    navigate('/');
  };

  return (
    <section className={styles.Home}>
      <AnimatePresence onExitComplete={handleExitComplete}>
        {showIframe && (
          <motion.div
            className={styles.container}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <iframe
              src="frames/onboard/index.html" /* https://mixtaperadio.web.app/ */
              className={styles.iframe}
              title="Onboard"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default IframeOnboard;